let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hWHS6")).then(() => parcelRequire('4cdiu'));